import { Component, OnInit } from '@angular/core';
import { UtilService } from '@app/utility/util.service';
import { ApiService } from '@app/utility/api.service';
import { Router, ActivatedRoute } from '@angular/router';

declare var $: any,moment : any
@Component({
  selector: 'app-customerEdit',
  templateUrl: './customerEdit.component.html',
  styleUrls: ['./customerEdit.component.scss']
})
export class CustomerEditComponent implements OnInit {

  constructor(
    private util: UtilService,
    private apiService: ApiService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }

  isExistingUser = false

  token = ""

  submitted = false
  //username = ""
  //userId=""
  //newPass = ""
  //confirmPass = ""
  //oldPassword = "";
  //isResetSuccess = false
  //tmpUsername = ""
  //tmpNewPass = ""

  ngOnInit() {

    //let cookieData = JSON.parse(localStorage.getItem("dpa_cc"))
    //this.username = cookieData["username"]
    //this.userId = cookieData["userId"]

    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['id'];
    });

    if(this.token == null || this.token.toString().trim().length == 0){
      this.util.ErrorDialog("ไม่พบข้อมูลการขอแก้ไข กรุณาลองใหม่อีกครั้ง")
    }
    else{
      this.validateToken()
    }

  }

  async validateToken(){
    this.util.ShowWaiting(true)
    let req = {
      token_id: this.token
    }
    console.log(this.token);
    let res: any = await this.apiService.get("crmservice", "contactLogSave", "token=" + this.token)
    if(this.util.isSuccessResponse(res) && res.RESMSG == "SUCCESS"){
      //this.username = res.username
      let req: any = {
        email: res.email,
        call_by: "1",
        url: this.util.baseUrl(),
        firstname: res.conName,
        lastname: res.conLastName,
        userid: res.userId
      }
      
      let resS: any = await this.apiService.postCustom("Crm", "SendMailSuccess", req)

      this.token = res.token_id
      $('#txtAnnount')[0].innerHTML = 'แก้ไขข้อมูลสำเร็จ'
      this.util.ShowWaiting(false)
      this.util.SuccessDialog("แก้ไขข้อมูลสำเร็จ")
    }
    else{
      $('#txtAnnount')[0].innerHTML = 'แก้ไขข้อมูลไม่สำเร็จ'
      this.util.ShowWaiting(false)
      this.util.ErrorDialog("ไม่พบข้อมูลการขอแก้ไข กรุณาลองใหม่อีกครั้ง")
    }
  }

  close() {
    window.close()
  }


}



// WEBPACK FOOTER //
// ./src/app/customerEdit/customerEdit.component.ts